import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-ts';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  constructor() { }

  private secretKey = 'aflkdj;fioperwquiofdjkapoer'

  public encodeObject(object: any): string {
    console.log("encodeObject", object)
    return CryptoJS.AES.encrypt(JSON.stringify(object), this.secretKey).toString();
  }

  public decodeObject(str: string): any {
    console.log("decodeObject : Str", str)
    const decryptedBytes = CryptoJS.AES.decrypt(str, this.secretKey);
    let returnval = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));

    console.log("decodeObject: return ", returnval )
    return returnval
  }
}
